import React from 'react';
import { connect } from 'react-redux';
import Container from '../components/Container';
import reqwest from 'reqwest';

if (process.env.BROWSER) {
    require('flexboxgrid');
}

const Contact = React.createClass({
    propTypes: {
        hidden: React.PropTypes.bool,
        image: React.PropTypes.string,
        slogan: React.PropTypes.string,
        first_and_lastname: React.PropTypes.string,
        telephone: React.PropTypes.string,
        email: React.PropTypes.string,
        message: React.PropTypes.string,
        submit: React.PropTypes.string
    },
    getInitialState: function() {
        return {
            success: "",
            error: ""
        };
    },
    _sendForm: function (event) {
        event.preventDefault();
        var name = this.refs.name.value;
        var tel = this.refs.tel.value;
        var email = this.refs.email.value;
        var message = this.refs.message.value;
        if(name == "" || email == "" || message == "") {
            this.setState({
                success: "",
                error: "Es wurden nicht alle erforderlichen Felder ausgefüllt. Bitte geben Sie ihren Namen, E-Mail und Nachricht an."
            });
            return false;
        }
        reqwest({
            url: '/sendmail',
            method: 'post',
            data: {
                name,
                tel,
                email,
                message
            },
            success: (data) => {
                if(data.success) {
                    this.setState({
                        success: "Ihre Nachricht wurde erfolgreich versendet.",
                        error: ""
                    });
                }
            }
        });
    },
    render: function() {
        return (
            !this.props.hidden ? (
                <Container>
                    <div id="contact-form" className="row contact-form">
                        <div className="row col-xs-12 col-md-6 center-xs middle-xs">
                            <div>
                                <img className="contact-image" src={this.props.image} alt={this.props.slogan} />
                                <h4>{this.props.slogan}</h4>
                            </div>
                        </div>
                            <form onSubmit={this._sendForm.bind(this)} className="col-xs-12 col-md-6">
                                {(this.state.error) ? (
                                    <p className="error">{this.state.error}</p>
                                ) : null}
                                <div>
                                    <input type="text" ref="name" name="name" placeholder={this.props.first_and_lastname} />
                                </div>
                                <div>
                                    <input type="text" ref="tel" name="tel" placeholder={this.props.telephone} />
                                </div>
                                <div>
                                    <input type="email" ref="email" name="email" placeholder={this.props.email} />
                                </div>
                                <div>
                                    <textarea ref="message" name="message" placeholder={this.props.message}></textarea>
                                </div>
                                {(this.state.success) ? (
                                    <p className="success">{this.state.success}</p>
                                ) : null}
                                <div>
                                    <button type="submit">{this.props.submit}</button>
                                </div>
                            </form>
                    </div>
                </Container>
            ) : null
        );
    }
});

const mapStateToProps = (state) => {
    return {
        hidden:  state.contact_form.hidden,
        image:  state.contact_form.image,
        slogan:  state.company.slogan,
        first_and_lastname:  state.contact_form.first_and_lastname,
        telephone:  state.contact_form.telephone,
        email:  state.contact_form.email,
        message:  state.contact_form.message,
        submit:  state.contact_form.submit
    };
};

export default connect(mapStateToProps)(Contact);



// WEBPACK FOOTER //
// ./src/js/containers/ContactForm.js